import { Box, Text } from "@chakra-ui/react";
import TourLayout from "../Layout/TourLayout";

export default function WidgetTour({ onCloseWidgetTour }) {
  return (
    <TourLayout onCloseTour={onCloseWidgetTour}>
      <Box fontSize={"md"}>
        <Text>
          Deploy your AI Assistants across multiple platforms. Embed them on
          your website, use them as virtual chatbots, or deploy on WhatsApp,
          Instagram, Telegram, or a Facebook Page. Or link it to a phone number
          from Twilio, Plivo, or Telnyx - ensuring your customers can engage
          with your business anywhere, anytime.
        </Text>
      </Box>
    </TourLayout>
  );
}
